var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-upload',{on:{"input":_vm.upload},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}},[_c('a',{staticClass:"button is-primary"},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}),_c('b-icon',{attrs:{"icon":"upload"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }